module.exports = __webpack_public_path__ + "static/squareandcompass-edbe70039fc15eac612aeec1c0244531.png";